import { State, Action, ActionType, INITIAL_CONFIG_ID, INITIAL_KPI_SETTINGS, INITIAL_STAY_DATE } from "../../../../shared/interfaces/kpi";
import { hasSubmenus, isKpiConfigEmpty } from "../../../../shared/utils/kpi";

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.INIT: {
      const firstPresetId = Object.keys(action.savedPresets)[0] || INITIAL_CONFIG_ID;
      const firstPreset = action.savedPresets[firstPresetId];
      const firstKPIKey = action.firstKPI && firstPreset?.kpiSettings[action.firstKPI] ? action.firstKPI : Object.keys(firstPreset?.kpiSettings || {})[0] || null;
      const firstKpiSettings = firstKPIKey ? firstPreset!.kpiSettings[firstKPIKey] : null;
      const editingKPI = firstKpiSettings ? { ...INITIAL_KPI_SETTINGS, ...firstKpiSettings } : INITIAL_KPI_SETTINGS;
      return {
        ...state,
        savedConfigurations: action.savedPresets,
        selectedConfigId: firstPresetId,
        editingPresetDate: firstPreset?.date || null,
        editingKPIKey: firstKPIKey,
        editingKPI,
        initialConfigurationsLoaded: true,
        sharedStayDate: action.initialStayDate ?? INITIAL_STAY_DATE,
      };
    }
    case ActionType.SELECT_PRESET: {
      const firstKpiKey = Object.keys(action.preset.kpiSettings)[0] || null;
      const editingKPI = firstKpiKey ? { ...INITIAL_KPI_SETTINGS, ...action.preset.kpiSettings[firstKpiKey] } : INITIAL_KPI_SETTINGS;
      return {
        ...state,
        selectedConfigId: action.id,
        editingPresetDate: action.preset.date || null,
        editingKPIKey: firstKpiKey,
        editingKPI,
        sharedStayDate: action.preset.stayDate,
      };
    }
    case ActionType.SELECT_KPI: return { ...state, editingKPIKey: action.key, editingKPI: { ...INITIAL_KPI_SETTINGS, ...action.config }, sharedStayDate:(action.config as any).stayDate ?? state.sharedStayDate,};
    case ActionType.UPDATE_EDITING_KPI: return { ...state, editingKPI: { ...state.editingKPI, ...action.updates } };
    case ActionType.UPDATE_PRESET_DATE:
      return { ...state, editingPresetDate: action.date, savedConfigurations: { ...state.savedConfigurations, [state.selectedConfigId]: { ...state.savedConfigurations[state.selectedConfigId], date: action.date } } };

    case ActionType.UPDATE_SHARED_STAY_DATE:
      return {
        ...state,
        sharedStayDate: {
          ...state.sharedStayDate,
          ...action.stayDate,
        },
      };

    case ActionType.APPLY_KPI_CHANGES: {
      if (!state.editingKPIKey) return state;
      const preset = state.savedConfigurations[state.selectedConfigId];
      const updatedKpiSettings = { ...preset.kpiSettings };

      const isConfigurable = hasSubmenus(action.currentKPISettings);

      if (!isConfigurable) {
        updatedKpiSettings[state.editingKPIKey] = INITIAL_KPI_SETTINGS;
      } else if (isKpiConfigEmpty(state.editingKPI)) {
        delete updatedKpiSettings[state.editingKPIKey];
      } else {
        updatedKpiSettings[state.editingKPIKey] = state.editingKPI;
      }

      const nextEditingKPI = updatedKpiSettings[state.editingKPIKey] || INITIAL_KPI_SETTINGS;

      return {
        ...state,
        savedConfigurations: {
          ...state.savedConfigurations,
          [state.selectedConfigId]: { ...preset, kpiSettings: updatedKpiSettings }
        },
        editingKPI: nextEditingKPI
      };
    }

    case ActionType.REMOVE_KPI_FROM_PRESET: {
      if (!action.key) return state;

      const preset = state.savedConfigurations[state.selectedConfigId];
      const updatedKpiSettings = { ...preset.kpiSettings };

      delete updatedKpiSettings[action.key];

      const nextKpiKey = Object.keys(updatedKpiSettings)[0] || null;
      const nextKpiConfig = nextKpiKey ? updatedKpiSettings[nextKpiKey] : INITIAL_KPI_SETTINGS;

      return {
        ...state,
        savedConfigurations: {
          ...state.savedConfigurations,
          [state.selectedConfigId]: { ...preset, kpiSettings: updatedKpiSettings }
        },
        editingKPIKey: nextKpiKey,
        editingKPI: nextKpiKey ? { ...INITIAL_KPI_SETTINGS, ...nextKpiConfig } : INITIAL_KPI_SETTINGS,
      };
    }

    case ActionType.SAVE_PRESET: return { ...state, savedConfigurations: { ...state.savedConfigurations, [state.selectedConfigId]: { ...state.savedConfigurations[state.selectedConfigId], name: action.name } } };
    case ActionType.NEW_PRESET: {
      const firstKPI = Object.keys(action.preset.kpiSettings)[0] || null;
      const editingKPI = firstKPI ? { ...INITIAL_KPI_SETTINGS, ...action.preset.kpiSettings[firstKPI] } : INITIAL_KPI_SETTINGS;
      return { ...state, savedConfigurations: { ...state.savedConfigurations, [action.id]: action.preset }, selectedConfigId: action.id, editingPresetDate: action.preset.date || null, editingKPIKey: firstKPI, editingKPI, sharedStayDate: action.preset.stayDate };
    }
    case ActionType.APPLY_STAY_DATE_CHANGES: {
      return {
        ...state,
        savedConfigurations: {
          ...state.savedConfigurations,
          [state.selectedConfigId]: {
            ...state.savedConfigurations[state.selectedConfigId],
            stayDate: action.stayDate,
          },
        },
      };
    }
    case ActionType.DELETE_PRESET: {
      const updated = { ...state.savedConfigurations }; delete updated[action.id];
      const nextId = Object.keys(updated)[0] || INITIAL_CONFIG_ID;
      const nextPreset = updated[nextId] || { name: "", date: null, kpiSettings: {}, stayDate: INITIAL_STAY_DATE };
      const nextKpiKey = Object.keys(nextPreset.kpiSettings)[0] || null;
      const editingKPI = nextKpiKey ? { ...INITIAL_KPI_SETTINGS, ...nextPreset.kpiSettings[nextKpiKey] } : INITIAL_KPI_SETTINGS;
      return {
        ...state,
        savedConfigurations: updated,
        selectedConfigId: nextId,
        editingPresetDate: nextPreset.date || null,
        editingKPIKey: nextKpiKey,
        editingKPI,
        sharedStayDate: nextPreset.stayDate
      };
    }
    default: return state;
  }
};